import $ from 'jquery';
import * as Sentry from '@sentry/browser';
import cogotoast from 'cogo-toast';

import { querySubscription, render } from '~/theseus';
import { authService } from '~/theseus/containers/Auth';
import Navbar from '~/theseus/components/Navbar';

import { subscribeOn } from '~/state/bridge';
import { getRGAdPlacementArray } from '~/state/AdPlacement/selectors';

import { sendErrorService } from '~/services/error';
import { jax, jaxPromise } from '~/api/core/legacy';

import { lb, close_lb } from './shared/lightbox';
import { init } from './shared/login';

import {
  params,
  subscribeToPixelChange,
  loadSetting,
  storeSetting,
  ad_schedule_toggle,
  ad_schedule,
  loiter,
  publishControls,
} from './components/common';

let active_only = true;
let filter_by_account = false;
let posts_with_ads_only = false;
let campaigns = [];
const audience = [];
const $campaigns = $('.campaigns');
const auto_refresh = false;
let refresh_campaign_i = 0;
// eslint-disable-next-line
let refresh_ad_i = -1;
let load_count = 0;
let posts = null;
let page_max = null;
let total_posts;
let page = 0;
let page_length = 10;
let timer_context = 0;
let timers = [];
const refresh_time_gap = 20000;

let page_id = null;
let account_id = null;
let placementOptions = [];

querySubscription('page_id', (id) => {
  page_id = id;
});

querySubscription('account_id', (id) => {
  account_id = id;
});

subscribeOn(getRGAdPlacementArray, (options) => {
  placementOptions = options;
});

let fb_pixel = null;
querySubscription(() => ['facebook-pixel', account_id], (newPixel) => {
  fb_pixel = newPixel;
});

if ('page' in params) {
  page = params.page - 1;
}

const campaign_markup = `
  <div class='campaigns__item'>
    <div class='campaigns__details'>
      <div class='campaigns__post-type'></div>
      <a class='campaigns__name'></a>
      <div class='campaigns__data'>
        <div class='campaigns__status'></div>
        <a class='campaigns__ads-man' href='#'>Ads Manager</a>
        <div class='campaigns__start-date'></div>
        <a class='campaigns__organic-details'>
          <div class='campaigns__tooltip'>View on Facebook</div>
          <div class='campaigns__organic-likes'></div>
          <div class='campaigns__organic-comments'></div>
          <div class='campaigns__organic-shares'></div>
        </a>
      </div>
      <a class='campaigns__actions-toggle' href='#'></a>
      <ul class='campaigns__actions-list hide'>
        <a class='campaigns__re-advertise' href='#'>Additional Ad within Campaign</a>
        <a class='campaigns__draft' href='#'>Clone Campaign</a>
        <a class='campaigns__archive' href='#'>Archive Campaign</a>
      </ul>
    </div>
  </div>
`;

const no_campaigns = `
  <p>Go to <a href='settings.html'>Settings | Help</a> under <a href='settings.html'>"Navigation Tab"</a> to learn how to set up and start posting different ad types.</p>
`;

// The labels for these fields are located in _dashboard.scss
// under '$stats-labels'.
const ad_markup = `
  <div class='campaigns__ad'>
    <div class='campaigns__ad-details'>
      <div class='campaigns__ad-row'>
        <div class='campaigns__ad-status'></div>
        <div class='campaigns__ad-s_date'></div>
        <div class='campaigns__ad-e_date'></div>
        <div class='campaigns__ad-d_budget'></div>
        <div class='campaigns__ad-spent'></div>
      </div>
      <div class='campaigns__ad-row'>
        <div class='campaigns__ad-reach'></div>
        <div class='campaigns__ad-clicks'></div>
        <div class='campaigns__ad-ctr'></div>
        <div class='campaigns__ad-cpc'></div>
        <div class='campaigns__ad-shares'></div>
        <div class='campaigns__ad-likes'></div>
        <div class='campaigns__ad-p_likes'></div>
        <div class='campaigns__ad-p_signup'></div>
        <div class='campaigns__ad-s_lead'></div>
        <div class='campaigns__ad-p_lead'></div>
        <div class='campaigns__ad-conversion'></div>
        <div class='campaigns__ad-cost_lead'></div>
      </div>
      <div class='campaigns__ad-row campaigns__ad-row--video hide'>
        <div class='campaigns__ad-video-10'></div>
        <div class='campaigns__ad-video-25'></div>
        <div class='campaigns__ad-video-50'></div>
        <div class='campaigns__ad-video-75'></div>
        <div class='campaigns__ad-video-100'></div>
      </div>
      <div class='campaigns__ad-row'>
        <div class='campaigns__ad-audience'></div>
        <div class='campaigns__ad-creator_name'></div>
        <div class='campaigns__ad-account'></div>
        <div class='campaigns__ad-actions'>
          <div class='ad-actions__pause'>Pause</div>
          <div class='ad-actions__active hide'>Activate</div>
        </div>
      </div>
    </div>
  </div>
`;

const re_ad_dom = `
  <div class='lightbox lightbox--re-ad'>
    <div class='lightbox__close'></div>
    <div class='lightbox__container'>
      <h2>Re-Advertise</h2>
      <button id='re-advertise' type='button'>Save and Readvertise</button>
    </div>
  </div>
`;

// id -> name for the user's ad accounts, so each ad row can say whose it
// is (the dashboard mixes accounts unless the filter is on). The FB SDK has
// no ambient session here, so the call must carry the auth machine's token
// explicitly (like every other Graph call in the app); rows render the raw
// act_ id until names load and upgrade on the next stats poll.
const account_names = {};
let account_names_attempts = 0;
function load_account_names() {
  account_names_attempts += 1;
  if (account_names_attempts > 30) {
    return; // give up quietly; rows keep showing raw act_ ids
  }

  const token = authService.state
    && authService.state.context
    && authService.state.context.authToken;
  if (!window.FB || !window.FB.api || !token) {
    setTimeout(load_account_names, 1000);
    return;
  }

  FB.api('/me/adaccounts', 'get', { fields: 'name,id', limit: 100, access_token: token }, (r) => {
    if (r && !r.error) {
      r.data.forEach((a) => { account_names[a.id] = a.name; });
    } else {
      setTimeout(load_account_names, 5000);
    }
  });
}
load_account_names();

function account_display(ad) {
  return account_names[ad.account_id] || ad.account_id || '';
}

const ad_keys = [
  { dom: 'status', mod: 'delivering' },
  { dom: 'audience', mod: 'audience_name' },
  { dom: 'creator_name', mod: 'creator_name' },
  { dom: 'account', mod: 'account_display' },
  { dom: 's_date', mod: 'date_start' },
  { dom: 'e_date', mod: 'date_stop' },
  { dom: 'd_budget', mod: 'daily_dollar' },
  { dom: 'spent', mod: 'spend' },
  { dom: 'reach', mod: 'impressions' },
  { dom: 'clicks', mod: 'link_click' },
  { dom: 'ctr', mod: 'ctr' },
  { dom: 'cpc', mod: 'cpc' },
  { dom: 'p_signup', mod: 'offsite_conversion_registration' },
  { dom: 's_lead', mod: 'offsite_conversion_checkout' },
  { dom: 'p_lead', mod: 'offsite_conversion_lead' },
  { dom: 'cost_lead', mod: 'cpl' },
  { dom: 'shares', mod: 'post' },
  { dom: 'likes', mod: 'post_like' },
  { dom: 'conversion', mod: 'cr' },
  { dom: 'p_likes', mod: 'like' },
  { dom: 'video-10', mod: 'video_10_sec_views' },
  { dom: 'video-25', mod: 'video_p25_views' },
  { dom: 'video-50', mod: 'video_p50_views' },
  { dom: 'video-75', mod: 'video_p75_views' },
  { dom: 'video-100', mod: 'video_p100_views' },
];

function set_filter_account(v) {
  if (v) {
    $('#account_filter').attr('checked', true);
  } else {
    $('#account_filter').attr('checked', false);
  }
  filter_by_account = v;
  load_data(page_id, account_id);
}

$('#account_filter').on('change', () => {
  if ($('#account_filter:checked').val()) {
    set_filter_account(true);
  } else {
    set_filter_account(false);
  }
});

function set_ads_only(v) {
  if (v) {
    $('#ads_only').attr('checked', true);
  } else {
    $('#ads_only').attr('checked', false);
  }
  posts_with_ads_only = v;
  load_data(page_id, account_id);
}

$('#ads_only').on('change', () => {
  if ($('#ads_only:checked').val()) {
    set_ads_only(true);
  } else {
    set_ads_only(false);
  }
});

function getPosts(pageId, accountId) {
  return () => {
    jax(
      'get_posts',
      {
        page_id: pageId,
        account_id: accountId,
        filter_by_account,
        posts_with_ads_only,
        active_only,
        page,
        page_length,
      },
      (r) => {
        total_posts = r.post_count;
        $('.c-filters').addClass('c-filters--show');
        // eslint-disable-next-line
        posts = r.posts;
        const push = total_posts <= page_length;
        show_data();
        $('.campaigns').removeClass('campaigns--loading');
        folio(page, push);
      },
      Sentry.captureException,
    );
  };
}

function load_data(pageId, accountId) {
  campaigns = [];
  $('.campaigns').addClass('campaigns--loading');
  loadSetting('page_length')
    .then((l) => {
      if (l) {
        page_length = l;
      }
    })
    .catch(Sentry.captureException)
    .finally(getPosts(pageId, accountId));
}

function show_data() {
  $(window).scrollTop(0);
  $campaigns.empty();
  timers.forEach((v) => {
    clearTimeout(v);
  });
  timer_context += 1;
  timers = [];
  campaigns = [];
  // TODO: `post` should probably be named `campaign` below
  posts.forEach((post) => {
    campaigns.push(post);
    post.$dom = $(campaign_markup);
    const { $dom } = post;

    const post_link = `https://facebook.com/${post.id}`;
    $campaigns.append($dom);
    if (post.state == 'draft_hidden') {
      $dom.addClass('campaigns__item--pending');
    }
    if (post.archived === true) {
      $dom.addClass('campaigns__item--archived');
    }
    $dom
      .find('.campaigns__name')
      .html(post.name)
      .attr({ href: post_link, target: '_blank' });
    $dom.find('.campaigns__ads-man').attr({
      href: `https://facebook.com/ads/manager/campaign/adsets/?act=${post.account_id.replace(
        'act_',
        '',
      )}&ids=${post.campaign_id}`,
      target: '_blank',
    });
    $dom
      .find('.campaigns__item-link > a')
      .attr({ 'xlink:href': post_link, target: '_blank' });
    $dom
      .find('.campaigns__organic-details')
      .attr({ href: post_link, target: '_blank' });
    $dom.find('.campaigns__start-date').html(post.created_at);
    $dom.find('.campaigns__organic-likes').html(post.stats.likes);
    $dom.find('.campaigns__organic-comments').html(post.stats.comments);
    $dom.find('.campaigns__organic-shares').html(post.stats.shares);
    $dom
      .find('.campaigns__draft')
      .attr('href', `${post.post_type}.html?id=${encodeURI(post.id)}`);
    $dom.find('.campaigns__post-type').html(post.post_type);
    $dom.find('.campaigns__re-advertise').on('click', () => {
      $dom.find('.campaigns__actions-list').addClass('hide');
      re_advertise(post.id, post.page_id, post.account_id);
      return false;
    });
    if (post.archived) $dom.find('.campaigns__archive').html('Remove from Archive');
    $dom.find('.campaigns__archive').on('click', () => {
      $dom.slideUp('fast');
      jax(
        'set_archive_post',
        {
          account_id,
          id: post.id,
          archived: !post.archived,
        },
        () => {},
        Sentry.captureException,
      );
      return false;
    });
    if (post.ads.length == 0) {
      $dom.find('.campaigns__ads-man').remove();
      $dom.find('.campaigns__re-advertise').html('Create an Ad For This Post');
      $dom.find('.campaigns__draft').html('Clone Post');
    }
    post.ads.forEach((ad, ii) => {
      ad.parent_info = { campaign: post, index: ii };
      inject(ad, post);
      timers.push(
        setTimeout(() => {
          ad_stats_timer(ad, timer_context, timers.length);
        }, Math.floor(Math.random() * refresh_time_gap)),
      );
    });
    $dom.find('.campaigns__actions-toggle').on('click', () => false);
    loiter(
      $dom,
      'campaigns__',
      'actions-toggle',
      'actions-list',
      300,
      (event) => {
        refresh_stats_post(post);
        const wH = $(window).innerHeight();
        const mP = event.clientY;
        const eH = 160;
        if (wH - mP <= eH) {
          $dom
            .find('.campaigns__actions-list')
            .addClass('campaigns__actions-list--top');
        }
      },
    );

    if (post.refresher_error) {
      const {
        error_user_msg,
        error_user_title,
        message,
      } = post.refresher_error;

      const $campaignItem = $(post.$dom[0]);
      $campaignItem.removeClass('campaigns__item--pending');
      $campaignItem
        .find('.campaigns__post-type')
        .after('<div class="refresher-error-icon">Error</div>')
        .after(
          `<div class="refresher-error hide">${error_user_title}</br>${error_user_msg}</br>${message}</div>`,
        );

      $campaignItem.find('.refresher-error-icon').hover(
        () => $campaignItem.find('.refresher-error').removeClass('hide'),
        () => $campaignItem.find('.refresher-error').addClass('hide'),
      );

      // The one publication error users can fix themselves: a missing pixel.
      // Offer the same one-click setup the create flow has; the publisher
      // retries every minute, so the ad recovers on its own afterwards.
      if ((message || '').indexOf('no pixels both in mcp and fb') !== -1) {
        const $fix = $('<button class="refresher-error-fix" type="button">Set up my pixel</button>');
        $campaignItem.find('.refresher-error-icon').after($fix);
        $fix.on('click', () => {
          $fix.prop('disabled', true).text('Setting up…');
          jax(
            'setup_fb_pixel',
            { account_id: post.account_id || account_id },
            () => {
              $fix.text('Pixel set up — your ad will retry automatically');
            },
            (r) => {
              $fix.prop('disabled', false).text('Set up my pixel');
              alert('We could not set up your pixel automatically. Please contact support.');
              Sentry.captureException(r);
            },
          );
        });
      }
    }
  });
  if (campaigns.length == 0) {
    $campaigns.addClass('campaigns--no-posts');
    $campaigns.append($(no_campaigns));
  } else {
    refresh_campaign_i = 0;
    refresh_ad_i = -1;
    if (++load_count == 1) {
      refresh();
    }
  }
}

function folio(in_page, in_show_data) {
  page_max = Math.floor(total_posts / page_length);
  const pages = new Array(page_max);
  pages.forEach((e, i) => {
    pages[i] = 0;
  });
  const $container = $(`
    <div class='pagination'>
      <div class=pp>
        <select id=pp>
          <option value=10>10</option>
          <option value=25>25</option>
          <option value=50>50</option>
          <option value=100>100</option>
        </select>
        <label for=pp>post per page</label>
      </div>
      <button type='button' class='pagination__first hide'>First </button>
      <button type='button' class='pagination__previous hide'>Back</button>
      <div class='pagination__pages'>of</div>
      <button type='button' class='pagination__next'>Next</button>
      <button type='button' class='pagination__last'>Last</button>
      <button type='button' id=archivedButton class=show-archived>Show Archived Posts</button>
    </div>
  `);
  $('.pagination').remove();
  $container
    .find(`#pp option[value="${page_length}"]`)
    .attr('selected', 'selected');
  $container.find('#pp').on('change', () => {
    page_length = $container.find('select option:selected').text();
    storeSetting('page_length', page_length);
    folio(in_page, true);
  });
  $container.find('.pagination__pages').attr('data-current-page', page + 1);
  $container.find('.pagination__pages').attr('data-max-page', page_max + 1);
  if (page >= 1) {
    $container.find('.pagination__previous').removeClass('hide');
  }
  if (page >= 2) {
    $container.find('.pagination__first').removeClass('hide');
  }
  if (page >= page_max) {
    $container.find('.pagination__next').addClass('hide');
  }
  if (page >= page_max - 1) {
    $container.find('.pagination__last').addClass('hide');
  }
  $container.find('.pagination__first').on('click', () => {
    page = 0;
    folio(page, true);
    dash_history();
  });
  $container.find('.pagination__last').on('click', () => {
    page = page_max;
    load_data(page_id, account_id);
    folio(page, true);
    dash_history();
  });
  $container.find('.pagination__previous').on('click', () => {
    if (page != 0) {
      page -= 1;
      load_data(page_id, account_id);
      folio(page, true);
      dash_history();
    }
  });
  $container.find('.pagination__next').on('click', () => {
    if (page != page_max) {
      page += 1;
      load_data(page_id, account_id);
      folio(page, true);
      dash_history();
    }
  });
  $container.find('.show-archived').on('click', () => {
    page = 0;
    active_only = !active_only;
    $('#archivedButton').addClass('show-archived--disabled').html('Loading...');
    load_data(page_id, account_id);
  });
  if (in_show_data) {
    show_data();
  }
  $('.container').append($container);
  if (active_only === false) $('#archivedButton').html('Show All Posts');
}

function dash_history() {
  // eslint-disable-next-line
  history.pushState("", "", `?page=${page + 1}`);
}

$(window).on('popstate', () => {
  if ('page' in params) {
    page = params.page - 1;
  } else {
    page = 0;
  }
  folio(page, true);
});

function inject(ad, campaign) {
  const fb_link = `https://facebook.com/ads/manager/ad/ads/?act=${ad.account_id}&ids=${ad.id}`;
  ad.$dom = $(ad_markup);
  campaign.$dom.append(ad.$dom);
  if (ad.lead_form_enabled) {
    campaign.$dom.addClass('campaigns__item--lead-ad');
    const $cn = campaign.$dom.find('.campaigns__name');
    const cnName = campaign.name;
    $cn.html(cnName.slice(0, cnName.indexOf(':')));
  }
  ad.$dom.find('.campaigns__ad-link > a').attr({
    'xlink:href': fb_link,
    target: '_blank',
  });
  if (ad.parent_info.campaign.post_type === 'video') {
    ad.$dom.find('.campaigns__ad-row--video').removeClass('hide');
  }
  if (ad.delivering == 'ACTIVE') {
    ad.$dom
      .find('.campaigns__ad-status')
      .addClass('campaigns__ad-status--active');
  } else if (ad.delivering == 'PAUSED' || ad.delivering == 'INACTIVE') {
    ad.$dom
      .find('.campaigns__ad-status')
      .addClass('campaigns__ad-status--stopped');
  }
  const publishState = publish_status(ad);
  if (publishState) {
    ad.$dom
      .find('.campaigns__ad-status')
      .addClass(`campaigns__ad-status--pending ${publishState.klass}`)
      .attr('title', publishState.title)
      .html(publishState.text);
  } else if (
    ad.effective_status == 'DRAFT'
    || (ad.delivering == '' && ad.state == 'final')
  ) {
    ad.$dom
      .find('.campaigns__ad-status')
      .addClass('campaigns__ad-status--pending')
      .html('PENDING');
  }
  ad.account_display = account_display(ad);
  ad_keys.forEach((vvv) => {
    ad.$dom
      .find(`.campaigns__ad-${vvv.dom}`)
      .addClass('normal')
      .html(ad[vvv.mod]);
  });
  ad.$dom.find('.ad-actions__active').on('click', () => {
    set_ad_status(ad, 'ACTIVE', ad.account_id);
  });
  ad.$dom.find('.ad-actions__pause', ad.account_id).on('click', () => {
    set_ad_status(ad, 'PAUSED', ad.account_id);
  });
  set_ad_status_btn(ad);
  if (ad.delivering == 'INACTIVE') {
    ad.$dom.find('.campaigns__ad-actions').remove();
  }
}

// The publisher's lifecycle for ads that haven't reached Facebook yet: fresh
// drafts publish within a minute; errored drafts retry once a minute up to 30
// times; then they give up (fixing the cause -- e.g. the pixel button --
// resets the count and they resume).
function publish_status(ad) {
  if (ad.state !== 'draft') {
    return null;
  }
  const retries = parseInt(ad.retry_count, 10) || 0;
  if (retries >= 30) {
    return {
      text: 'GAVE UP',
      klass: 'campaigns__ad-status--failed',
      title: 'We stopped retrying this ad. Fix the error shown and set up again, or contact support.',
    };
  }
  if (ad.refresher_error || retries > 1) {
    return {
      text: `RETRYING (${retries}/30)`,
      klass: 'campaigns__ad-status--retrying',
      title: 'Publishing hit a problem; we retry once a minute. Hover the Error badge for details.',
    };
  }
  return {
    text: 'PUBLISHING',
    klass: 'campaigns__ad-status--publishing',
    title: 'Your ad is being published to Facebook. This usually takes under a minute.',
  };
}

function re_advertise(post_id, pageId, accountId) {
  const $re_dom = $(re_ad_dom);
  let send_ad_schedule = null;
  $('body').append($re_dom);
  $('.lightbox').on('click', (e) => {
    if ($(e.target).hasClass('lightbox')) {
      close_lb();
    }
  });
  publishControls($re_dom.find('.lightbox__container'));
  $re_dom.find('.campaign').removeClass('campaign--hidden');
  $re_dom.find('.ad-type__container').remove();
  $re_dom.find('.button-group').remove();
  audience.forEach((e, i) => {
    const $opt = $('<option></option>');
    $opt.attr('value', i).html(e.name);
    $('#choose-audience').append($opt);
  });
  $('#re-advertise').on('click', () => {
    const i = $('#choose-audience').val();
    const ad_campaign_budget = $('#choose-budget').val();
    const ad_campaign_length = $('#campaign-length').val();
    if (ad_schedule_toggle == 'schedule') {
      send_ad_schedule = ad_schedule;
    } else if (ad_schedule_toggle == 'all') {
      send_ad_schedule = null;
    }
    if (!ad_campaign_budget || !ad_campaign_length) {
      alert(
        'Please add a daily budget and length before trying to create an ad',
      );
      return false;
    }

    return jaxPromise('fb_pixel', { account_id: accountId })
      .then(({ pixel_id }) => {
        jax(
          'create_ad_post',
          {
            page_id: pageId,
            account_id: accountId,
            fb_pixel_id: pixel_id,
            post_id,
            link: '',
            daily_dollar: $('#choose-budget').val(),
            days: $('#campaign-length').val(),
            targeting: JSON.stringify(audience[i].targeting),
            audience_name: audience[i].name,
            audience_id: audience[i].id,
            name: '',
            placement_options: JSON.stringify(placementOptions),
            schedule: JSON.stringify(send_ad_schedule),
          },
          (r) => {
            lb(
              'Your Ad Was Created',
              'success',
              post_id,
              r.campaign_id,
              true,
              true,
            );
          },
          (r) => {
            lb(
              'Your Ad Could Not Be Created',
              'fail',
              post_id,
              null,
              null,
              null,
            );
            Sentry.captureException(r);
          },
        );
        lb(
          'Please Wait While We Boost Your Post',
          'loading',
          post_id,
          null,
          true,
          true,
        );
        return false;
      })
      .catch((err) => {
        cogotoast.error(
          'Unable to retrieve your Facebook pixelso we were unable to create your ad. Please try again or contact support',
        );

        sendErrorService(err, 'fb-pixel', { account_id });
      });
  });
  $re_dom.find('.lightbox__close').on('click', close_lb);
}

function set_ad_status_btn(ad) {
  ad.$dom.find('.ad-actions__pause').removeClass('ad-actions__pause--loading');
  ad.$dom
    .find('.ad-actions__active')
    .removeClass('ad-actions__active--loading');
  if (ad.configured_status == 'ACTIVE') {
    ad.$dom.find('.ad-actions__pause').removeClass('hide');
    ad.$dom.find('.ad-actions__active').addClass('hide');
  } else if (ad.configured_status == 'PAUSED') {
    ad.$dom.find('.ad-actions__pause').addClass('hide');
    ad.$dom.find('.ad-actions__active').removeClass('hide');
  }
}

function set_ad_status(ad, status, accountId) {
  // The loading state stays on until fresh stats come back: ad_stats_timer's
  // success path ends in set_ad_status_btn, which clears it and swaps the
  // pause/resume buttons to match the new status.
  ad.$dom.find('.ad-actions__pause').addClass('ad-actions__pause--loading');
  ad.$dom.find('.ad-actions__active').addClass('ad-actions__active--loading');
  jax(
    'set_ad_status',
    {
      account_id: accountId,
      ad_id: ad.id,
      status,
    },
    () => {
      ad_stats_timer(ad);
    },
    (r) => {
      set_ad_status_btn(ad);
      alert(
        'We could not pause your ad. Please check if this post still exists on Facebook.',
      );
      Sentry.captureException(r);
    },
  );
}

function refresh_stats_post(campaign, on_success) {
  if (['draft_hidden', 'draft_public'].indexOf(campaign.state) != -1) {
    if (on_success) {
      on_success();
    }
    return;
  }
  jax(
    'refresh_stats_post',
    {
      post_id: campaign.id,
      page_id: campaign.page_id,
    },
    (r) => {
      campaign.old_stats = campaign.stats;
      campaign.stats = r;
      ['likes', 'comments', 'shares'].forEach((k) => {
        const field = campaign.$dom.find(`.campaigns__organic-${k}`);
        field.html(campaign.stats[k]);
        if (campaign.stats[k] != campaign.old_stats[k]) {
          field.removeClass('normal');
          field.removeClass('pink');
          field.addClass('red');
          setTimeout(() => {
            field.removeClass('red');
            field.addClass('pink');
          }, 202);
        } else if (!on_success) {
          field.removeClass('pink');
          field.addClass('red');
          setTimeout(() => {
            field.removeClass('red');
            field.addClass('normal');
          }, 202);
        }
      });
      if (on_success) {
        on_success();
      }
    },
    () => {
      if (on_success) {
        on_success();
      }
    },
  );
}

function refresh() {
  if (!auto_refresh) {
    return;
  }
  const c = campaigns[refresh_campaign_i];
  refresh_stats_post(c, () => {
    if (c.ads.length > 0) {
      // eslint-disable-next-line
      refresh_ad_i = 0;
    } else {
      refresh_campaign_i = (refresh_campaign_i + 1) % campaigns.length;
    }
    setTimeout(refresh, 5000);
  });
}

function ad_stats_timer(vv, in_timer_context, i) {
  jax(
    'get_stats_ad',
    {
      ad_id: vv.id,
      account_id: vv.account_id,
    },
    (r) => {
      r.parent_info = vv.parent_info;
      r.$dom = vv.$dom;
      const old_ad = vv;
      vv = r;
      vv.parent_info.campaign.ads[vv.parent_info.index] = vv;
      if (vv.delivering == 'ACTIVE') {
        vv.$dom
          .find('.campaigns__ad-status')
          .addClass('campaigns__ad-status--active');
        vv.$dom
          .find('.campaigns__ad-status')
          .removeClass('campaigns__ad-status--stopped');
      } else if (vv.delivering == 'PAUSED' || vv.delivering == 'INACTIVE') {
        vv.$dom
          .find('.campaigns__ad-status')
          .addClass('campaigns__ad-status--stopped');
      } else {
        vv.$dom
          .find('.campaigns__ad-status')
          .removeClass('campaigns__ad-status--active');
      }
      if (vv.effective_status != 'DRAFT') {
        vv.parent_info.campaign.$dom.removeClass('campaigns__item--pending');
      }
      vv.account_display = account_display(vv);
      ad_keys.forEach((vvv) => {
        const field = vv.$dom.find(`.campaigns__ad-${vvv.dom}`);
        if (vvv.dom == 'status' && vv[vvv.mod] == '') {
          field.addClass('campaigns__ad-status--pending');
          field.html('PENDING');
        } else if (vvv.dom == 'status' && vv[vvv.mod] != '') {
          field.removeClass('campaigns__ad-status--pending');
          field.html(vv[vvv.mod]);
        } else {
          field.html(vv[vvv.mod]);
        }
        if (vv[vvv.mod] != old_ad[vvv.mod]) {
          field.removeClass('normal');
          field.removeClass('pink');
          field.addClass('red');
          setTimeout(() => {
            field.removeClass('red');
            field.addClass('pink');
          }, 202);
        }
      });
      const $statusField = vv.$dom.find('.campaigns__ad-status');
      $statusField.removeClass('campaigns__ad-status--publishing campaigns__ad-status--retrying campaigns__ad-status--failed');
      const publishState = publish_status(vv);
      if (publishState) {
        $statusField
          .addClass(`campaigns__ad-status--pending ${publishState.klass}`)
          .attr('title', publishState.title)
          .html(publishState.text);
      } else {
        $statusField.removeAttr('title');
      }
      set_ad_status_btn(vv);
      if (timer_context == in_timer_context) {
        timers[i] = setTimeout(() => {
          ad_stats_timer(vv, timer_context, i);
        }, Math.floor(Math.random() * refresh_time_gap));
      }
    },
    Sentry.captureException,
  );
}

$('body').keyup(function (e) {
  if (e.keyCode == 82) {
    // eslint-disable-next-line
    console.log("🔑 the key is to make it.");
    $(this).toggleClass('🔑');
  }
  if (e.keyCode == 27) {
    close_lb();
  }
});

init()
  .then((({ pageId, accountId }) => {
    load_data(pageId, accountId);
  }));
